<template>
  <v-container fluid class="px-0 py-0">
    <v-tabs v-model="displayedTab" background-color="integrity" dark show-arrows icons-and-text>
      <v-tab v-for="(tab, tabIndex) in tabConfig" :key="tabIndex" :value="tabIndex + 1">
        {{ tab.title }}
        <v-icon>{{ tab.icon }}</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="displayedTab">
      <template>
        <v-tab-item v-for="(tab, tabIndex) in tabConfig" :key="tabIndex">
          <v-container>
            <v-row>
              <v-col cols="12" class="pt-0 px-0">
                <component :is="tab.component" v-bind="tab.propsData" />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </template>
    </v-tabs-items>
  </v-container>
</template>

<style scoped>
</style>

<script>
import Details from '@/components/Client/LineOfBusiness/Vehicles/Vehicle/Details.vue';
import VehicleCoverages from '@/components/Client/LineOfBusiness/Vehicles/Vehicle/VehicleCoverages.vue';
import analyticsService from '@/services/shared/analyticsService.js';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Vehicles',
  components: {
    Details,
    VehicleCoverages
  },
  data: function () {
    return {
      loading: true
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode', 'activeVehicleTab', 'autoVehicleTabGtagConfig']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return ((this.$route.params.lobId || null) === null)
        ? this.selectedLineOfBusinessCode
        : this.$route.params.lobId;
    },
    vehicleId: function () {
      return this.$route.params.vehicleId;
    },
    tabConfig: function () {
      var tabs = [
        {
          title: 'Info',
          icon: 'mdi-information-outline',
          component: 'Details',
          gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Policy Info Tab' }
        },
        {
          title: 'Coverages',
          icon: 'mdi-shield-outline',
          component: 'VehicleCoverages',
          gtagConfig: this.autoVehicleTabGtagConfig
        }
      ];

      return tabs;
    },
    displayedTab: {
      get: function () {
        return this.activeVehicleTab;
      },
      set: function (val) {
        this.tabChange(val);
      }
    }
  },
  methods: {
    ...mapActions(['setActiveVehicleTab']),
    tabChange: function (value) {
      this.setActiveVehicleTab(value);
      var tab = this.tabConfig[value];
      if ((tab || null) !== null) {
        analyticsService.sendEvent(this.$gtag, tab.gtagConfig.action, tab.gtagConfig.category, tab.gtagConfig.label);
      }
    }
  }
};
</script>
